<template>
  <li>
    <label class="group relative block cursor-pointer">
      <input
        :checked="option.selected"
        class="absolute inset-0 opacity-0"
        :disabled="shouldDisplayDisabledState"
        :name="`step-${radioName || step.id}`"
        type="radio"
        :value="option.trackingValue"
        @keydown.enter="onClick"
      />
      <LargePicker
        :addon="option.addon"
        :best-deal
        :color="option.color"
        :contextual-callout
        :data-qa="dataQaAttribute"
        :disabled="shouldDisplayDisabledState"
        :hide-sold-out
        :illustration="option.icon"
        :index
        :is-good-deal="option.goodDeal"
        :is-small
        :label
        :label-highlight="option.highlight"
        :loading
        :prefix="option.style?.prefix"
        :price="description"
        :selected="option.selected"
        :sub-label
        :tag
        @click="onClick"
      />
    </label>
  </li>
</template>

<script lang="ts" setup>
import { useStepOptionInteraction } from '~/scopes/product-core/components/presentationals/CustomizationFunnel/composables/useStepOptionInteraction/useStepOptionInteraction'

import type { Step } from '../../utils/types'
import LargePicker from '../LargePicker/LargePicker.vue'

const props = withDefaults(
  defineProps<{
    step: Step
    option: Step['options'][number]
    index: number
    isGroupLoading?: boolean
    isSmall?: boolean
    hideSoldOut?: boolean
    radioName?: string
    firstPickerId?: string
  }>(),
  {
    isGroupLoading: false,
    isSmall: false,
    hideSoldOut: false,
    radioName: '',
    firstPickerId: '',
  },
)

const emit = defineEmits<{
  click: [Step['options'][number], Step]
  changed: [Step['options'][number], Step]
}>()

const {
  loading,
  description,
  label,
  subLabel,
  tag,
  shouldDisplayDisabledState,
  bestDeal,
  contextualCallout,
  dataQaAttribute,
  onClick,
} = useStepOptionInteraction(
  props,
  {
    onClick: (option, step) => emit('click', option, step),
    onChanged: (option, step) => emit('changed', option, step),
  },
  { withKeyboardSpecialCase: true },
)
</script>
